import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
const SEARCH_PARAM = 'search';
const TYPE_PARAM = 'type';
const ALL_BUCKETS = [
    'Invoices',
    'Payment',
    'Amendments',
    'Integrations',
    'ProposalLifecycle'
];
const ALL_BUCKETS_SET = new Set(ALL_BUCKETS);
const isFilterBucket = (value)=>ALL_BUCKETS_SET.has(value);
const parseSearch = (search)=>{
    var _get;
    return (_get = new URLSearchParams(search).get(SEARCH_PARAM)) !== null && _get !== void 0 ? _get : '';
};
const parseAppliedTypes = (search)=>{
    const raw = new URLSearchParams(search).get(TYPE_PARAM);
    if (raw == null) return new Set();
    const parsed = raw.split(',').map((token)=>token.trim()).filter(isFilterBucket);
    return new Set(parsed);
};
const writeParam = (params, key, value)=>{
    if (value == null || value === '') {
        params.delete(key);
    } else {
        params.set(key, value);
    }
};
const serializeAppliedTypes = (next)=>{
    if (next.size === 0) return null;
    return ALL_BUCKETS.filter((bucket)=>next.has(bucket)).join(',');
};
export const useActivityLogUrlState = ()=>{
    const location = useLocation();
    const history = useHistory();
    const searchCommitted = useMemo(()=>parseSearch(location.search), [
        location.search
    ]);
    const appliedTypes = useMemo(()=>parseAppliedTypes(location.search), [
        location.search
    ]);
    const updateSearch = useCallback((mutate)=>{
        const params = new URLSearchParams(history.location.search);
        mutate(params);
        const next = params.toString();
        history.replace(_object_spread_props(_object_spread({}, history.location), {
            search: next === '' ? '' : "?".concat(next)
        }));
    }, [
        history
    ]);
    const setSearchCommitted = useCallback((value)=>updateSearch((params)=>writeParam(params, SEARCH_PARAM, value)), [
        updateSearch
    ]);
    const setAppliedTypes = useCallback((value)=>updateSearch((params)=>writeParam(params, TYPE_PARAM, serializeAppliedTypes(value))), [
        updateSearch
    ]);
    return {
        searchCommitted,
        appliedTypes,
        setSearchCommitted,
        setAppliedTypes
    };
};
